import { render, staticRenderFns } from "./RemoveFavoriteBtn.vue?vue&type=template&id=24564568&scoped=true"
import script from "./RemoveFavoriteBtn.vue?vue&type=script&lang=js"
export * from "./RemoveFavoriteBtn.vue?vue&type=script&lang=js"
import style0 from "./RemoveFavoriteBtn.vue?vue&type=style&index=0&id=24564568&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24564568",
  null
  
)

export default component.exports